<template src="./archivioISO9001.html"></template>

<script>
//Importo le funzioni dal file 'api.home.js'
import {
    carica_file_filtri,
    get_file,
    elimina_file,
    getFileCliente,
    download_file,
    elimina_cartella
} from "@/api/api.dati.js";

import DialogCartella from "@/components/dialog/DialogCartella.vue";
import DialogRenameDirectory from "@/components/dialog/DialogRenameDirectory.vue";
import DialogSpostaElemento from "@/components/dialog/DialogSpostaElemento.vue";
import DialogAnteprimaDocumento from "@/components/dialog/DialogAnteprimaDocumento.vue";

import mixinArchivio from "../../utils/dati/mixinArchivio";

export default {
    components: { DialogCartella, DialogRenameDirectory, DialogSpostaElemento, DialogAnteprimaDocumento },

    props: {
        compCode: { type: String, default: "" },
    },
    mixins: [mixinArchivio],

    data: () => ({
        //per caricamento file
        file: [],//null
        fileSupp: [],
        countFile: 0,
        //per i nomi dei file e cartelle
        listaDati: [],
        //Per la dialog
        dialog: false,
        nomeCartella: "",
        selectedItem: -1,
        loading: false,
        flagBack: false,

        selectedRow: null,
        previousRow: {},
        selectedRowSupp: null,
        selectedRowSuppBack: null,
        codeCartellaOrigine: "",
        pathOrigine: "",
        posizioneUrl: "",
        pathIndietro: "",

        //visualizzazione cartelle/file
        flagStyle: true,

        //alert
        successFile: false,
        errorFile: false,
        successFileDel: false,
        errorFileDel: false,
        successDir: false,
        errorDir: false,

        isPulsating: false,
        refreshFlag: false,

        cartellaSpeciale: false,

        opzioni: [],
        opzioniFolder: null,

        dialogRenameDir: false,
        DirectoryRename: null,
        TipoDirectoryRename: -1,

        menuView: false,

        dialogSposta: false,
        elementoDaSpostare: null,

        dialogAnteprima: false,
        elementoAnteprima: null,
    }),

    methods: {
        //Funzione per caricamento file
        async uploadFile() {
            this.loading = true;
            let upload = false;

            for (let i = 0; i < this.fileSupp.length; i++) {
                let par = ""; let path = ""; let spaziNomeFile = false;

                //controllo se il nome contiene spazi
                //spaziNomeFile = this.controlloNomeFile(this.fileSupp[i].name);

                if (!spaziNomeFile) {
                    let formData = new FormData();
                    formData.append("file", this.fileSupp[i]);

                    path = this.$functions.getPathFtpISO9001() + "/" + this.posizioneUrl + "/" + this.fileSupp[i].name;
                    //else path = this.controlloPathFileCaricato(this.pathIndietro);

                    par = "?path=" + encodeURIComponent(path)
                    let res = await carica_file_filtri(formData, par);

                    if (res.data.message != "OK") {
                        upload = true;
                        this.$toast.alert("Errore! Impossibile caricare il file: " + this.fileSupp[i].name + ". " + res.data.message);
                        break;
                    }

                    if (i == this.fileSupp.length - 1)
                        if (!upload) {
                            await this.getResources(true, false, true); //carico risorse aggiornate
                            this.successFile = true;
                            setTimeout(() => {
                                this.successFile = false;
                            }, 3000);
                        } else {
                            this.errorFile = true;
                            setTimeout(() => {
                                this.errorFile = false;
                            }, 3000);
                        }
                } else this.$toast.alert("Errore! Impossibile caricare il file. Sono presenti degli spazi nel nome file");
            }

            this.loading = false;
        },

        /* controlloNomeFile(nameFile) {
            let spaziNomeFile = false
            if (nameFile.includes(" ")) spaziNomeFile = true;
            return spaziNomeFile;
        }, */

        handleFileChange(e) {
            this.file = e.target.files[0];
        },

        async getResources(value, back, refreshAfterUpload) {
            this.loading = true;

            let par = { path: "", refresh: false };
            let lunghezzaUrl = 0;
            this.resetCampi();

            if (back) {
                let path = this.$functions.getPathFtpISO9001() + "/" + this.posizioneUrl;
                if (path != "") path = this.controlloPathFileEliminato(path); //controllo se nel path è presente nome file
                par.path = path;
                lunghezzaUrl = path.slice(0, path.length).length;
            }
            else {
                par.path = this.$functions.getPathFtpISO9001() + "/" + this.posizioneUrl;
            }
            if (value && lunghezzaUrl > 7) par.refresh = true;
            if (refreshAfterUpload) par.path = this.$functions.getPathFtpISO9001() + "/" + this.posizioneUrl;

            this.listaDati = [];
            if (par.path == "") par.path = this.$functions.getPathFtpISO9001() + "/" + this.posizioneUrl;

            let res = await get_file(par);
            if (res.data.length > 0 && res.data != []) {
                this.listaDati = res.data;
                if (this.listaDati.length > 0) {
                    //salvo il path di origine delle risorse
                    this.pathOrigine = this.listaDati[0].path;
                    //cartelle certificazione
                }
                this.setPosUrl(value);
            }
            //ordino cartelle per Ragione Sociale
            this.orderListaCartelle();

            this.loading = false;
        },

        orderListaCartelle() {
            this.listaDati.sort((a, b) => {
                if (!a.cliente) return 1;
                if (!b.cliente) return -1;
                return a.cliente.localeCompare(b.cliente, 'it', { sensitivity: 'base' });
            });
        },

        controlloPathFileEliminato(path) {
            if (path[path.length - 1].includes(".")) path.pop();
            return path;
        },

        controlloPathFileCaricato(path) {
            let url = path.split("/");
            if (url[url.length - 1] == url[url.length - 2]) path = url.slice(0, -1).join("/");
            else path = url.join("/");
            return path;
        },

        resetCampi() {
            this.file = [];
            this.fileSupp = [];
            this.countFile = 0;
            this.flagBack = false;
            this.successFile = false;
            this.errorFile = false;
            this.successFileDel = false;
            this.errorFileDel = false;
            this.successDir = false;
            this.errorDir = false;
            this.pathIndietro = this.$functions.getPathFtpISO9001() + "/" + this.posizioneUrl;
            this.opzioni = this.opzioniComplete();
            this.opzioniFolder = null;
            this.DirectoryRename = null;
        },

        opzioniComplete() {
            return [...this.getOpzioni(), { Opzione: 3, Nome: "Sposta" }];
        },

        anteprimaFile(oggetto) {
            if (oggetto.tipo != "file") return;

            const estensione = (oggetto.estensione || "").toLowerCase();
            if (estensione === ".docx" || estensione === ".xlsx" || estensione === ".xls" || estensione === ".csv") {
                this.elementoAnteprima = oggetto;
                this.dialogAnteprima = true;
                return;
            }

            let ur = (oggetto.path.substring(19, oggetto.path.length).split('/')
                .map(encodeURIComponent)
                .join('/'));
            window.open("https://www." + ur, "_blank");
        },

        async scaricaFile(oggetto, anteprima) {
            //controllo se oggetto selezionato è un file
            if (oggetto.tipo != "file") return;

            this.loading = true;
            let par = "?path=" + encodeURIComponent(oggetto.path)
            const response = await download_file(par);
            //ricavo il tipo di file (estensione file)
            let url = response.config.url.split("%5C");
            let tipoFile = url[url.length - 1];
            tipoFile = tipoFile.split(".").pop();
            //setto il nome del file scaricato
            let nomeFile = oggetto.nome;
            if (oggetto.revisione > 0) nomeFile = oggetto.nome + "_" + oggetto.revisione;
            //download file
            this.downloadFile(response.data, tipoFile, nomeFile, anteprima);

            this.loading = false;
        },

        async downloadFile(data, tipoFile, nomeFile, anteprima) {
            let mimeTypes = this.getMimeTypes();
            let blob = new Blob([data], { type: mimeTypes[tipoFile] || "application/octet-stream" });
            let url = window.URL.createObjectURL(blob);

            //if (!anteprima) {
            let a = document.createElement("a");
            a.href = url;

            a.download = nomeFile;//+ `.${tipoFile}`;

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            window.URL.revokeObjectURL(url);
        },

        async eliminaFile(oggetto) {
            //E' un Pop-Up di conferma, come il 'toast'
            let confirm = await this.$confirm.open(
                "Elimina",
                "Eliminare il file: <br><b>" + oggetto.nome + oggetto.estensione + "</b>?"
            );
            if (!confirm) return;

            let par = "?path=" + encodeURIComponent(this.selectedRow.path)
            let res = await elimina_file(oggetto, par);

            if (res.data == "OK") {
                this.getResources(true, false, true);
                this.successFileDel = true;
                setTimeout(() => {
                    this.successFileDel = false;
                }, 3000);
            } else {
                this.errorFileDel = true;
                setTimeout(() => {
                    this.errorFileDel = false;
                }, 3000);
            }
            //else this.$toast.alert("Errore! Impossibile eliminare il file. " + res.data);
        },

        selectRow(i) {
            Object.assign(this.previousRow, this.selectedRow);
            this.selectedRow = i;
            if (this.selectedRow.tipo != "file") {
                if (this.codeCartellaOrigine == "") {
                    this.codeCartellaOrigine = this.selectedRow.nome;
                    this.selectedRow.nome = "";
                }
                this.flagBack = false;
                this.getListaFile();
            }
        },

        async getListaFile() {
            this.loading = true;

            this.cartellaSpeciale = false;
            this.selectedRow.compCode = this.codeCartellaOrigine;
            //controllo per cartella FSC e PEFC e FPC
            if (this.selectedRow.compCode == "FSC" || this.selectedRow.compCode == "PEFC" || this.selectedRow.compCode == "FPC") this.selectedRow.nome = this.selectedRow.compCode;

            let res = await getFileCliente(this.selectedRow);
            if (res.data != null) {
                this.listaDati = res.data;
            }
            this.selectedRow.compCode = this.codeCartellaOrigine;
            this.setPosUrl();// setto indirizzo per sapere l'url in cui si sta lavorando
            this.selectedItem = null;
            this.loading = false;
        },

        async backDirectory() {
            this.loading = true;

            this.selectedItem = null;

            //this.setUrlFile();//controllo se selezionato un file
            //this.$functions.getPathFtpISO9001() + "/" + this.posizioneUrl
            //this.posizioneUrl = 

            this.listaDati = [];
            let res = "";
            this.posizioneUrl = this.posizioneUrl.includes('/') ? this.posizioneUrl.slice(0, this.posizioneUrl.lastIndexOf('/')) : ""
            this.pathIndietro = ""; //resetto path indietro, così attivo l'evento watch che l'aggiorna
            {
                let par = {
                    path: this.$functions.getPathFtpISO9001() + "/" + this.posizioneUrl
                };
                res = await getFileCliente(par);
            }

            if (res.data != null || res.data != []) {
                this.listaDati = res.data;
                if (this.listaDati[0].path == this.pathOrigine) {
                    this.flagBack = true;
                    this.codeCartellaOrigine = "";
                }

                //ordino cartelle per Ragione Sociale
                this.orderListaCartelle();
            }
            this.selectedRow = null;

            this.loading = false;
        },

        setUrlFile() {
            if (this.selectedRow != null) {
                let path = this.selectedRow.path.split("/");
                let value = path[path.length - 1];
                value = value.split(".");

                if (value.length >= 2) {
                    for (let i = 0; i < path.length - 1; i++) {
                        if (i == 0) this.selectedRow.path = path[i];
                        else this.selectedRow.path = this.selectedRow.path + "/" + path[i];
                    }
                }
            }
        },

        getPath() {
            let url = "";
            let path = this.selectedRow.path.split("\\");
            for (let i = 0; i < path.length - 1; i++) {
                if (i == 0) url = path[i];
                else url = url + "\\" + path[i];
            }
            this.selectedRow.path = url;
        },
        getPathFtpISO9001() {
            let url = "";
            let path = this.selectedRow.path.split("/");
            for (let i = 0; i < path.length - 1; i++) {
                if (i == 0) url = path[i];
                else url = url + "/" + path[i];
            }
            this.selectedRow.path = url;
        },

        chiudiDialog(success, error) {
            this.successDir = success;
            this.errorDir = error;
            if (this.successDir)
                setTimeout(() => {
                    this.successDir = false;
                }, 3000);
            else if (this.errorDir)
                setTimeout(() => {
                    this.errorDir = false;
                }, 3000);
            this.dialog = false;
        },

        setPosUrl(value) {
            let pos = "";
            if (this.listaDati.length > 0) {
                pos = this.listaDati[0].path.split('/');
                this.posizioneUrl = pos.slice(7, -1).join('/');
            }
            else {
                pos = this.selectedRow.path.split('/');
                this.posizioneUrl = pos.slice(7, pos.length).join('/');
            }
            //serve nel caso si crei una nuova cartella dopo essere tornati indietro con la navigazione
            this.pathIndietro = "";
            /* if (value == true) this.refreshFlag = true;
            else this.refreshFlag = false; */
        },

        showPermanent(item) {
            if (item.tipo == "folder") this.opzioniFolder = item;
            else this.opzioniFolder = null;
        },

        async SelectOpzioneMenu(item) {
            if (item.Opzione == 1) await this.EliminaDirectory(this.opzioniFolder);
            if (item.Opzione == 2) {
                //controllo se cartella origine cliente
                await this.RenameDirectory(this.opzioniFolder);
            }
            if (item.Opzione == 3) this.apriDialogSposta(this.opzioniFolder);
        },

        apriDialogSposta(elemento) {
            this.elementoDaSpostare = elemento;
            this.dialogSposta = true;
        },

        chiudiDialogSposta() {
            this.dialogSposta = false;
            this.elementoDaSpostare = null;
        },

        spostamentoCompletato() {
            this.chiudiDialogSposta();
            this.getResources(true, false, true);
        },

        async EliminaDirectory(folder) {
            let str = "";
            if (folder.cliente != "" && folder.cliente != null) str = "Eliminare la cartella: <br><b>" + folder.nome + "</b> di <b>" + folder.cliente + "</b>?<br><br>Tutte le risorse al suo interno andranno perse.";
            else str = "Eliminare la cartella: <br><b>" + folder.nome + "</b>?<br><br>Tutte le risorse al suo interno andranno perse.";

            let confirm = await this.$confirm.open(
                "Elimina",
                str
            );
            if (!confirm) return;

            this.loading = true;

            let par = "?path=" + encodeURIComponent(folder.path);
            let data = {
                nome: folder.nome,
                path: folder.path
            }
            let res = await elimina_cartella(par);//data

            if (res.data == "OK") {
                this.$toast.info("Cartella eliminata");
                this.getResources(true, false, true);
            }
            else
                this.$toast.alert("Errore nell'eliminazione della cartella " + folder.nome);

            this.loading = false;
        },

        async RenameDirectory(folder, value) {
            if (this.dialogRenameDir) {
                this.DirectoryRename = null;
                this.dialogRenameDir = false;
                if (this.selectedRow == null) this.setPathRenameDirBack();
                if (value != -1) await this.getResources(true);//carico dati aggiornati
            }
            else {
                this.DirectoryRename = folder;
                this.dialogRenameDir = true;
            }
        },

        setPathRenameDirBack() {
            if (this.selectedRowSuppBack != null) {
                this.selectedRow = this.selectedRowSuppBack;
                let path = this.selectedRow.path.split("/");
                let pathDir = path.slice(0, -1).join("/");
                this.selectedRow.path = pathDir;
            }
            else this.selectedRow = { path: this.pathIndietro };
        },
    },

    mounted() {
        this.getResources(false);
    },

    watch: {
        file(newVal) {
            if (newVal.length > 0) {
                this.isPulsating = true;
                this.countFile = 0;
                //controllo se si aggiunge il file in drag & drop o con singolo click
                if (newVal.length <= 1) this.fileSupp.push(this.file[0]);
                else {
                    this.fileSupp = [];
                    this.fileSupp = this.file
                }
                //if (this.listaSottoDirectory.length > 0) this.chiudiDialogSceltaDirectory();
                this.countFile = this.fileSupp.length;
            }
            else {
                this.isPulsating = false;
                this.countFile = 0;
                this.fileSupp = [];
            }
        },

        pathIndietro(newVal) {
            if (newVal == "" || newVal == null)
                this.pathIndietro = this.$functions.getPathFtpISO9001() + "/" + this.posizioneUrl;
        },
    },

    created() {
        if (this.getRole != "admin")
            this.$router.push({ path: "/" });

        this.opzioni = this.opzioniComplete();
        this.pathIndietro = this.$functions.getPathFtpISO9001() + "/" + this.posizioneUrl;
    },

    computed: {
        getRole() {
            return this.$store.getters["user/getRole"];
        },

        radiceArchivio() {
            return this.$functions.getPathFtpISO9001();
        },
    }
};
</script>

<style scoped>
.zoom-card {
    transition: transform 0.3s ease;
}

.zoom-card:hover {
    transform: scale(1.1);
}

@keyframes pulsate {
    0% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.2);
    }

    100% {
        transform: scale(1);
    }
}

.pulsating {
    animation: pulsate 1s infinite;
}
</style>
